import './main.css';
import React from 'react';
//import * as T from './template.tsx';
import Homepage from './pages/homepage';
import Collection from './pages/collection';
import Shop from './pages/shop';
import Account from './pages/account';
import About from './pages/about';

import { useLocation,useOutlet } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { createRef } from 'react'

function App() {
  const location = useLocation();
  const currentOutlet = useOutlet();
  const routes = [
    { path: '/', name: 'Home', element: <Homepage />, nodeRef: createRef<HTMLDivElement>() },
    { path: '/collection', name: 'Collection', element: <Collection />, nodeRef: createRef<HTMLDivElement>() }, 
    { path: '/shop', name: 'Shop', element: <Shop />, nodeRef: createRef<HTMLDivElement>() },
    { path: '/account', name: 'Account', element: <Account />, nodeRef: createRef<HTMLDivElement>() },
    { path: '/about', name: 'About', element: <About />, nodeRef: createRef<HTMLDivElement>() },
  ]
  const nodeRR = routes.find((route) => route.path === location.pathname)!

  function scrollTop(){
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      })
  };
  return (
    <div className="w-full h-full text-ubuntu">
      <SwitchTransition>
        <CSSTransition key={location.pathname} nodeRef={nodeRR.nodeRef} timeout={500} classNames='' onEnter={scrollTop} unmountOnExit>
          {(state) => (
            <div ref={nodeRR.nodeRef} className='w-full h-full'>
                {currentOutlet}
            </div>
          )}
          </CSSTransition>
      </SwitchTransition>
    </div>
    
  );
}

export default App;
